document.addEventListener('DOMContentLoaded', function () {
  const addToCartButtons = document.querySelectorAll('.book-card__actions input[type="submit"]');

  addToCartButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      const form = button.closest('form');
      const vendorInput = form.querySelector('input[name="properties[vendor]"]');
      const newVendor = vendorInput ? vendorInput.value : null;

      if (!newVendor) {
        form.submit();
        return;
      }

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart.items.length === 0) {
            form.submit();
            return;
          }

          const cartVendor = cart.items[0].properties.vendor;

          if (cartVendor === newVendor) {
            form.submit();
          } else {
            Swal.fire({
              title: 'Different Seller Detected',
              text: `Your cart already contains items from "${cartVendor.split(" ")[0]}". Adding this product will replace your cart with items from "${newVendor.split(" ")[0]}". Do you want to continue?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, Replace Cart',
              cancelButtonText: 'No, Keep Current Items',
              customClass: {
                popup: 'swal-popup',
                title: 'swal-title',
                text: 'swal-text',
                confirmButton: 'swal-confirm-button',
                cancelButton: 'swal-cancel-button'
              }
            }).then(result => {
              if (result.isConfirmed) {
                fetch('/cart/clear.js', {
                  method: 'POST'
                }).then(() => {
                  form.submit();
                }).catch(error => {
                  console.error('Error clearing cart:', error);
                });
              }
            });
          }
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
          form.submit();
        });
    });
  });
});
